import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import formatting from './formatting'

dayjs.locale('ru')

// see: gist.github.com/realmyst/1262561

function pluralize(value, names) {
  if (!value) return ''
  var cases = [2, 0, 1, 1, 1, 2]
  return (
    value +
    ' ' +
    names[
      value % 100 > 4 && value % 100 < 20
        ? 2
        : cases[value % 10 < 5 ? value % 10 : 5]
    ]
  )
}
Vue.filter('pluralize', function(value, names) {
  return pluralize(value, names)
})

Vue.filter('questions', function(value) {
  return pluralize(value, ['вопрос', 'вопроса', 'вопросов'])
})

Vue.filter('attempts', function(value) {
  return pluralize(value, ['попытка', 'попытки', 'попыток'])
})

Vue.filter('minutes', function(value) {
  return pluralize(value, ['минута', 'минуты', 'минут'])
})

Vue.filter('date', function(value) {
  if (value) {
    return dayjs(String(value)).format('DD MMMM YYYY')
  }
  return ''
})

Vue.filter('datetime', function(value) {
  if (value) {
    return dayjs(String(value)).format('DD.MM.YY HH:mm')
  }
  return ''
})

Vue.filter('score', function(value) {
  if (value) {
    return Number(value).toFixed(1)
  }
  return ''
})

Vue.filter('limitWord', function(value, max) {
  if (value) {
    if (value.length > max) {
      if (value.indexOf(' ') > -1) {
        return value.split(' ')[0]
      } else {
        return value.substr(0, max)
      }
    }
    return value.substr(0, max)
  }
  return ''
})

Vue.filter('fileSize', function(value) {
  if (value && parseInt(value)) {
    if (value < 1000) {
      return '1 Kb'
    }

    if (value < 1000 * 1000 && value > 1000) {
      return `${Math.floor(value / 1000)} Kb`
    }

    const mb = Math.floor(value / (1000 * 1000))
    const kb = Math.floor((value - mb * 1000 * 1000) / 1000) + ''
    return `${mb}.${kb ? kb.substr(0, 1) : '0'} Mb`
  }
  return ''
})

Vue.filter('future', function(value) {
  if (value) {
    return formatting.future(value)
  }
  return ''
})

Vue.filter('past', function(value) {
  if (value) {
    return formatting.past(value)
  }
  return ''
})
